const accentEAgu = String.fromCharCode(233);
const accentEGrave = String.fromCharCode(232);
const accentOAgu = String.fromCharCode(243);
const accentC = String.fromCharCode(231);
const accentAAgu = String.fromCharCode(225);
const accentAGrave = String.fromCharCode(224);
const accentUAgu = String.fromCharCode(250);
const accentIAgu = String.fromCharCode(237);

const dictionary = {
	en: {
		title: 'Click to pay invoice',
		errorTitle: 'Oops...',
		paymentSuccessTitle: 'Success!',
		paymentSuccessBody: 'We have received your payment.',
		errorMessage: 'Something went wrong with your invoice! Please try again.',
		downloadReceipt: 'Download receipt',
		voidMessage:
			'This invoice has been voided. For more information please contact us.',
		text: 'Text',
		call: 'Call',
		billed: 'Billed to',
		forText: 'for',
		requested: 'Requested on',
		branding: 'Powered by',
		pay: 'Pay',
		download: 'Download receipt',
		back: 'Back',
		creditCard: 'Pay by card',
		choosePaymentMethod: 'Card or bank account',
		refundText: 'Refund',
		creditCardText: 'Card',
		directDebitText: 'Pre-authorized debit',
		usBankAchText: 'US bank account (ACH)',
		achTimingHint:
			'ACH direct debit typically takes 1–3 business days to clear. You can leave this page and refresh later to see the final status.',
		achPendingTitle: 'Direct debit submitted',
		achPendingBody:
			'Your US bank (ACH) payment is processing. Clearing the bank can take 1–3 business days. You can leave this page—refresh later to see when it’s complete.',
		directDebitPendingTitle: 'Direct debit submitted',
		directDebitPendingBody:
			'Your pre-authorized debit payment is processing. Clearing the bank can take up to 5 business days. You can leave this page—refresh later to see when it’s complete.',
		date: 'Date',
		type: 'Type',
		detail: 'Detail',
		amount: 'Amount',
		paidBy: 'Paid by',
		receipt: 'Receipt',
		referenceNumber: 'Reference number',
		description: 'Description',
		datePaid: 'Date paid',
		paymentMethod: 'Payment method',
	},
	fr: {
		title: 'Cliquez pour payer la facture',
		errorTitle: 'Euh oh...',
		errorMessage: `Un probl${accentEGrave}me est survenu avec votre facture! Veuillez r${accentEAgu}essayer.`,
		paymentSuccessTitle: `Succ${accentEGrave}s!`,
		paymentSuccessBody: ` Nous avons re${accentC}u votre paiement.`,
		downloadReceipt: `T${accentEAgu}l${accentEAgu}charger le re${accentC}u`,
		voidMessage: `Cette facture a ${accentEAgu}t${accentEAgu} annul${accentEAgu}e. Pour plus d'informations, contactez nous.`,
		text: 'Texte',
		call: 'Appel',
		billed: `Factur${accentEAgu} ${accentAGrave}`,
		forText: 'pour',
		requested: `Demand${accentEAgu}`,
		branding: 'Produit par',
		pay: 'Payer',
		download: `T${accentEAgu}l${accentEAgu}charger le re${accentC}u`,
		back: `Retourner`,
		creditCard: `Payer par carte`,
		choosePaymentMethod: `Carte ou compte bancaire`,
		refundText: 'Rembourser',
		creditCardText: `Carte`,
		directDebitText: `Pr${accentEAgu}l${accentAGrave}vement pr${accentEAgu}autoris${accentEAgu}`,
		usBankAchText: `Compte bancaire US (ACH)`,
		achTimingHint: `Les virements ACH prennent g${accentEAgu}n${accentEAgu}ralement 1 ${accentAGrave} 3 jours ouvrables pour ${accentEAgu}tre compens${accentEAgu}s. Vous pouvez quitter cette page et la rafra${accentIAgu}chir plus tard pour voir l${accentEGrave}'${accentEAgu}tat final.`,
		achPendingTitle: `Virement bancaire soumis`,
		achPendingBody: `Votre paiement ACH (banque US) est en traitement. L'encaissement peut prendre 1 à 3 jours ouvrables. Vous pouvez quitter cette page et la rafraîchir plus tard pour voir l'état.`,
		directDebitPendingTitle: `Virement bancaire soumis`,
		directDebitPendingBody: `Votre paiement par pr${accentEAgu}l${accentAGrave}vement pr${accentEAgu}autoris${accentEAgu} est en traitement. L'encaissement peut prendre jusqu${accentEGrave}'${accentAGrave} 5 jours ouvrables. Vous pouvez quitter cette page et la rafraîchir plus tard pour voir l'état.`,
		date: 'Date',
		type: 'Type',
		detail: `D${accentEAgu}tail`,
		amount: 'Somme',
		paidBy: `Pay${accentEAgu} par`,
		receipt: `Le re${accentC}u`,
		referenceNumber: `Num${accentEAgu}ro de r${accentEAgu}ference`,
		description: 'La description',
		datePaid: 'Date de paiement',
		paymentMethod: 'Mode de paiement',
	},
	es: {
		title: 'Haga clic para pagar la factura',
		errorTitle: 'Uh oh...',
		errorMessage: `¡Algo sali${accentOAgu} mal con tu factura! Int${accentEAgu}ntalo de nuevo.`,
		paymentSuccessTitle: `¡Éxito!`,
		paymentSuccessBody: `  Hemos recibido su pago.`,
		downloadReceipt: 'Descargar recibo',
		voidMessage: `Esta factura ha sido anulada. Para m${accentAAgu}s informaci${accentOAgu}n cont${accentAAgu}ctenos.`,
		text: 'Texto',
		call: 'Llamada',
		billed: 'Facturado a',
		forText: 'por',
		requested: 'Solicitado en',
		branding: 'Creado por',
		pay: 'Pagar',
		download: `Descargar recibo`,
		back: 'Regresa',
		creditCard: `Pagar con tarjeta`,
		choosePaymentMethod: `Tarjeta o cuenta bancaria`,
		refundText: 'Reembolso',
		creditCardText: `Tarjeta`,
		directDebitText: `D${accentEAgu}bito preautorizado`,
		usBankAchText: `Cuenta bancaria de EE. UU. (ACH)`,
		achTimingHint: `Las transferencias ACH suelen tardar de 1 a 3 d${accentIAgu}as h${accentAAgu}biles en completarse. Puede salir de esta p${accentAAgu}gina y actualizarla m${accentAAgu}s tarde para ver el estado final.`,
		achPendingTitle: 'Transferencia bancaria enviada',
		achPendingBody: `Su pago ACH (banco de EE. UU.) se est${accentAAgu} procesando. La compensaci${accentOAgu}n puede tardar de 1 a 3 d${accentIAgu}as h${accentAAgu}biles. Puede salir de esta p${accentAAgu}gina; actualice m${accentAAgu}s tarde para ver el estado.`,
		directDebitPendingTitle: 'Transferencia bancaria enviada',
		directDebitPendingBody: `Su pago por d${accentEAgu}bito preautorizado se est${accentAAgu} procesando. La compensaci${accentOAgu}n puede tardar hasta 5 d${accentIAgu}as h${accentAAgu}biles. Puede salir de esta p${accentAAgu}gina; actualice m${accentAAgu}s tarde para ver el estado.`,
		date: 'Fecha',
		type: 'Tipo',
		detail: 'Detalle',
		amount: 'Cantidad',
		paidBy: 'Pagado por',
		receipt: 'Recibo',
		referenceNumber: `N${accentUAgu}mero de referencia`,
		description: `Descripci${accentOAgu}n`,
		datePaid: 'Fecha de pago',
		paymentMethod: `M${accentEGrave}todo de pago`,
	},
};

export default dictionary;
